import { render, staticRenderFns } from "./MessagesChart.vue?vue&type=template&id=2b8baece&scoped=true"
import script from "./MessagesChart.vue?vue&type=script&lang=js"
export * from "./MessagesChart.vue?vue&type=script&lang=js"
import style0 from "./MessagesChart.vue?vue&type=style&index=0&id=2b8baece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8baece",
  null
  
)

export default component.exports